import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { BreadcrumbService } from './breadcrumb.service';
import { Breadcrumb } from './breadcrumb';
import { Observable } from 'rxjs';

@Component({
  selector: 'breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  public breadcrumbs: Observable<Breadcrumb[]>;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public translate: TranslateService
  ) { }

  // toimiskohan tässä pairwise ja päivitetään vain se mikä on muuttunut
  // tällöin jokainen komponentti ei tarvi päivittää breadcrumbin dynaamisia osia manuaalisesti
  ngOnInit() {
    this.breadcrumbs = this.breadcrumbService.breadcrumb;
    // build breadcrumb on initial page load, since navigationEnd-event does not get fired here
    this.breadcrumbService.buildBreadcrumb(this.activatedRoute.root);
    // otherwise build it based on the router events
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      distinctUntilChanged()
    ).subscribe(() => {
      this.breadcrumbService.buildBreadcrumb(this.activatedRoute.root);
    });
  }

}
